var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 1.46031e-05C12.6462 1.46031e-05 12.1775 0.18564 11.8162 0.54689L5.625 6.71876L5.48812 6.85564L5.44938 7.05126L5.01937 9.23876L4.82438 10.1563L5.7425 9.96126L7.93 9.53126L8.125 9.49251L8.26188 9.35564L14.4338 3.16439C14.6924 2.90505 14.8685 2.57494 14.9399 2.21566C15.0112 1.85639 14.9746 1.48403 14.8346 1.14554C14.6946 0.807048 14.4576 0.51757 14.1534 0.3136C13.8491 0.109631 13.4913 0.000924561 13.125 1.46031e-05ZM13.125 1.21126C13.2712 1.21126 13.4156 1.28626 13.555 1.42564C13.8331 1.70439 13.8331 2.00689 13.555 2.28501L7.5 8.34064L6.42562 8.55564L6.64062 7.48126L12.6956 1.42626C12.8344 1.28751 12.9788 1.21126 13.125 1.21126ZM0 2.48064V14.9806H12.5V6.73814L11.25 7.98814V13.7306H1.25V3.73064H6.9925L8.2425 2.48064H0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOld);
export default __webpack_public_path__ + "static/media/edit-old.ea43c3cccf1c41a92554d4c7ea3399fb.svg";
export { ForwardRef as ReactComponent };